export default __webpack_public_path__ + "static/media/P-014.bf189f21.png";